<template>
  <div>
    <h1>Hola</h1>
    <b-row>
      <b-col>
        <b-card>
          <iframe
            width="800"
            height="600"
            src="https://datastudio.google.com/embed/reporting/3b5bcb8e-c060-4782-8357-d24e72183d6e/page/CLk9C"
            frameborder="0"
            style="border: 0"
          ></iframe>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <h2>Otra cosa</h2>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Prueba",
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {}
};
</script>

<style></style>
